import {
	COMPANY_CONTACT_LOOKUP_CREDITS,
	CompanyContactLookup,
	companyContactLookupOf,
	ContactLookupSettings,
	EMAIL_LOOKUP_CREDITS,
	PHONE_LOOKUP_CREDITS,
	personContactLookupsOf,
} from "@signalist/shared-types";

/** One lookup the person placed on the row is charged for: its text key and its price. */
export interface PlacementLookupPrice {
	key: "priceLookup.email" | "priceLookup.phone" | "priceLookup.companyContact";
	count: number;
}

/**
 * What the person a tracker's search places on the company's lead row is looked up for, at what
 * price, as the list's settings ask (PREC-4570): decided by the shared-types predicates the API
 * runs and charges on (`personContactLookupsOf`, `companyContactLookupOf`), priced from shared-types.
 */
export function placementLookupPrices(list: ContactLookupSettings): PlacementLookupPrice[] {
	const own = personContactLookupsOf(list);
	const prices: PlacementLookupPrice[] = [];

	if (own.email) {
		prices.push({ key: "priceLookup.email", count: EMAIL_LOOKUP_CREDITS });
	}

	if (own.phone) {
		prices.push({ key: "priceLookup.phone", count: PHONE_LOOKUP_CREDITS });
	}

	if (companyContactLookupOf(list) !== CompanyContactLookup.OFF) {
		prices.push({ key: "priceLookup.companyContact", count: COMPANY_CONTACT_LOOKUP_CREDITS });
	}

	return prices;
}
